import React from 'react'

import { Container, FlexColumn } from 'components/common/Containers'
import LandingItem from 'components/common/sections/Landing/components/LandingItem/LandingItem'

import styles from './Features.module.scss'

interface Props {
  data: {
    title: string
    description: string
    benefits: string[]
    image: string
  }[]
}
const Features: React.FC<Props> = ({ data }) => {
  return (
    <Container className={styles.containerOverflowHidden}>
      <FlexColumn className={styles.row} align="normal" gap="0px">
        {data.map((el, i) => (
          <LandingItem
            key={el.title}
            title={el.title}
            description={el.description}
            benefits={el.benefits}
            imgSrc={el.image}
            layout={i % 2 === 0 ? 'imgRight' : 'imgLeft'}
          />
        ))}
      </FlexColumn>
    </Container>
  )
}

export default Features
